import {
  AudioHighlightMetadataType,
  KeywordSummaryAudioHighlightMetadata,
} from '@modules/feedback/components/AudioType/types';
import { getStartEndTimeFromAudioSummaryMetadata } from '@modules/feedback/components/AudioType/utils';
import { FeedbackLabel, FeedbackLabelType } from 'v2/core/entities/feedback';
import { AudioConversationMessage } from 'v2/core/entities/feedback/content';
import { EntityLabel } from 'v2/core/entities/feedback/labels';
import { SentimentName } from 'v2/core/entities/fields';

export const getKeywordSummaryAudioHighlightMetadata = (
  selectedLabels: FeedbackLabel[],
  audioConversation: AudioConversationMessage[],
): KeywordSummaryAudioHighlightMetadata[] => {
  const keywordLabels = selectedLabels.filter(
    (label): label is EntityLabel => label.type === FeedbackLabelType.Entity,
  );

  if (!keywordLabels.length) {
    return [];
  }

  const keywordSummaryAudioHighlightMetadata: KeywordSummaryAudioHighlightMetadata[] =
    keywordLabels.reduce(
      (result: KeywordSummaryAudioHighlightMetadata[], keywordLabel) => {
        if (!keywordLabel.keywordSummary?.units?.length) {
          return result;
        }

        return [
          ...result,
          ...keywordLabel.keywordSummary.units.map((summary, index) => {
            const { startTime, endTime } =
              getStartEndTimeFromAudioSummaryMetadata(
                summary.metadata,
                audioConversation,
              );
            const firstSummaryLocation = summary.metadata?.location?.[0];

            const highlightMetadata: KeywordSummaryAudioHighlightMetadata = {
              labelID: keywordLabel.id,
              labelDisplayName: keywordLabel.displayName,
              type: AudioHighlightMetadataType.KeywordSummary,
              sentiment:
                keywordLabel.aggregatedSentiment ?? SentimentName.NEUTRAL,
              summaryText: summary.text,
              summaryIndex: index,
              summaryCount: keywordLabel?.keywordSummary?.units?.length ?? 0,
              startTime,
              endTime,
              msgIndex:
                firstSummaryLocation?.__typename === 'IndexTypeConversation'
                  ? firstSummaryLocation.messageIndex
                  : 0,
            };

            return highlightMetadata;
          }),
        ];
      },
      [],
    );

  return keywordSummaryAudioHighlightMetadata;
};
